import { CertificationType } from 'src/common/enums/certification';
import PT1RedBadge from 'src/images/svgs/certifications/PT1_Badge.svg';
import SAL1BlueBadge from 'src/images/svgs/certifications/SAL1_Badge.svg';

export const getCertificationNameAndLogo = (certificationType: CertificationType | null) => {
  switch (certificationType) {
    case CertificationType.PT1:
      return { certificateName: 'Junior Penetration Tester (PT1) Certified', certLogo: PT1RedBadge };
    case CertificationType.SAL1:
      return { certificateName: 'Security Analyst Level 1 (SAL1) Certified', certLogo: SAL1BlueBadge };
    default:
      return { certificateName: '', certLogo: '' };
  }
};
